/* React */
import React, { useEffect } from "react";

/* Ionic */
import { IonMenuToggle } from "@ionic/react";

/* React Redux */
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "src/redux/store";

/* Thunks */
import { fetchUserRoles } from "src/redux/thunks/auth/userRolesThunk";

/* Component */
import NavItem from "src/components/shared/nav-item/NavItem";

/* Constants */
import { MAIN_MENU_NAV_ITEMS } from "src/shared/constants/menu/NavItems";

/* Stylesheet */
import styles from "./NavContainer.module.scss";

/* Interfaces */
import { NavItemProps } from "src/shared/interfaces/common/NavItem";

const NavContainer: React.FC = () => {
  const dispatch = useDispatch<AppDispatch>();

  const isAuthenticated = useSelector(
    (state: RootState) =>
      state.auth.data?.isAuthenticated ?? false
  );
  const roles = useSelector(
    (state: RootState) => state.auth.roles
  );

  useEffect(() => {
    if (isAuthenticated && roles.length === 0) {
      dispatch(fetchUserRoles());
    }
  }, [dispatch, isAuthenticated, roles.length]);

  // Hide items whose required Keycloak role the user lacks
  const navItems = MAIN_MENU_NAV_ITEMS.filter(
    (item: NavItemProps) =>
      !item.requiredRole ||
      roles.includes(item.requiredRole)
  );

  return (
    <div className={styles.nav_container}>
      <IonMenuToggle>
        {navItems.map(
          (item: NavItemProps, index: number) => {
            return (
              <NavItem
                key={index}
                item={item}
                showLines={false}
                showName={true}
                scssProps={{
                  paddingStart: "32px",
                  activeColor:
                    "var(--ion-gradient-secondary)",
                }}
              />
            );
          }
        )}
      </IonMenuToggle>
    </div>
  );
};

export default NavContainer;
